import scrollTop from './scroll-top';
/**
 * Get the offset top of any DOM element
 * @param {HTMLElement} el - the element we need to check
 * @returns {number} the element y position in px
 */
export default function offsetTop(el) {
    return Math.abs(scrollTop() + el.getBoundingClientRect().top);
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/dom/offset-top.js